import { useMemo, useState } from "react";
import MaskMultiSelectScroll from "@/components/MaskMultiSelectScroll";
import { Option } from "@/constants/common";
import { useDebounce } from "@/hooks/use-debounce";
import { useReferringAgencyList } from "@/queries/use-referring-agency";
import { formatReferringAgencyLabel } from "@/utils/referring-agency-utils";
import { DEF_PAGINATION, DGT_Pagination } from "@/utils/utils";

export interface ReferringAgencyFilterSelectProps {
  value: Option[];
  onChange: (agencies: Option[]) => void;
}

const ReferringAgencyFilterSelect = ({
  value,
  onChange,
}: ReferringAgencyFilterSelectProps) => {
  const [searchKey, setSearchKey] = useDebounce("");
  const [pagination, setPagination] = useState<DGT_Pagination>(DEF_PAGINATION);
  const { data, isFetching } = useReferringAgencyList({
    pagination,
    isArchived: false,
    searchKey,
  });

  const options = useMemo<Option[]>(() => {
    const fetched: Option[] = (data?.data?.content ?? []).map((agency) => ({
      value: agency.uuid ?? "",
      label: formatReferringAgencyLabel(agency),
    }));
    const selected = value ?? [];
    const idKey = Object.keys(fetched[0] ?? selected[0] ?? {})[0];
    const missing = selected.filter(
      (s) => !fetched.some((o) => o[idKey] === s[idKey])
    );
    return [...missing, ...fetched];
  }, [data, value]);

  return (
    <MaskMultiSelectScroll
      options={options}
      value={value}
      loading={isFetching}
      onSearch={setSearchKey}
      onChange={(agencies) => onChange(agencies ?? [])}
      pagination={pagination}
      setPagination={setPagination}
      totalElements={data?.data?.page?.totalElements}
    />
  );
};

export default ReferringAgencyFilterSelect;
